import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import publicKnowledgeBasesAPI from '../../api/publicKnowledgeBases';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getPublicKnowledgeBases(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_PUBLIC_KNOWLEDGE_BASES_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await publicKnowledgeBasesAPI.get();
      commit(types.default.SET_PUBLIC_KNOWLEDGE_BASES, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_PUBLIC_KNOWLEDGE_BASES_UI_FLAG, {
        isFetching: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_PUBLIC_KNOWLEDGE_BASES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_PUBLIC_KNOWLEDGE_BASES]: MutationHelpers.set,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
